import { render, staticRenderFns } from "./alarmPush.vue?vue&type=template&id=f4152d04&"
import script from "./alarmPush.vue?vue&type=script&lang=js&"
export * from "./alarmPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports